import React from 'react'
import styled from 'styled-components'

const StyledSectionTitle = styled.h3`
  font-size: ${({ theme }) => theme.typography.fontSize.section};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text.primary};
  margin-bottom: ${({ theme }) => theme.spacing.medium};
`

export const DataSectionTitle: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  return <StyledSectionTitle>{children}</StyledSectionTitle>
}
